import {MobileSize} from "@/components/responsive";
import {useState} from "react";
import parse from "html-react-parser";
import {ImageWithFallback} from "@/components";

export default function AboutPolCard({title, desc, image = "", features = [], parentClasses = "", ...otherProps}) {

    const [showMore, setShowMore] = useState(false);

    return (
        <div
            className={`about-pol-card pt-10 lg:pt-[3.25rem] px-4 lg:px-8 pb-8 rounded-t-[2.125rem] rounded-b-3xl lg:rounded-[2.938rem] bg-white border-2 duration-300 my-5 ${parentClasses}`} {...otherProps}>
            <div className="flex items-center justify-center lg:justify-between flex-wrap">
                <h3 className="font-bold text-xl lg:text-2xl text-pol-dark-800">{title}</h3>
                <div className="relative w-[3.125rem] h-[3.125rem]">
                    <ImageWithFallback
                        src={image}
                        fill
                        alt={title}
                        className="object-contain"
                    />
                </div>
            </div>
            <div
                className={`relative overflow-hidden lg:h-auto lg:pb-6 lg:border-b lg:border-b-pol-light-gray-2 ${showMore ? "h-auto" : "h-[12.688rem]"}`}>
                {
                    !showMore ? <div className="absolute bottom-0 w-full h-14 lg:hidden"
                                     style={{background: "linear-gradient(180deg, rgba(255,255,255,0) 20%, rgba(255,255,255,1) 80%)"}}/>
                        : null
                }
                <div className="lg:text-lg text-pol-gray-600 mt-6 lg:mt-8 text-justify leading-[184%]">
                    {
                        parse(desc || "<span></span>")
                    }
                </div>
            </div>
            <MobileSize>
                <div className="text-center pb-3 border-b border-b-pol-light-gray-2">
                    {
                        !showMore ?
                            <button className="text-pol-blue font-semibold"
                                    onClick={() => setShowMore(true)}>
                                <span>بیشتر</span>
                                <i className="inline-block icon-simple-arrow-left -rotate-90 mr-2 text-xs"/>
                            </button>
                            : null
                    }
                </div>
            </MobileSize>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-5 mt-10 lg:mt-4">
                {features.map((item, index) => (
                    <div key={index}
                         className="flex flex-row-reverse lg:flex-row items-start justify-between lg:justify-start">
                        <i className="icon-square-tick text-pol-light-brown text-[1.1rem]"></i>
                        <p className="lg:mr-2.5 lg:text-sm font-semibold text-pol-light-brown">{item || ""}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}
